<div class="back-button">
  <span class="copy-s btn btn-plain" (click)="backButton.emit()">
    <span class="mb-icon mb-icon-step-back"></span>
    <span *ngIf="title" [innerHTML]="title"></span>
  </span>
</div>
<mb-consent-overlay
  *ngIf="bypassedEmbedHTML"
  [providerConfig]="consentProviderConfig"
  [backgroundImageUrl]="backgroundImageUrl"
>
  <ng-template>
    <div class="embed-wrapper" [innerHTML]="bypassedEmbedHTML"></div>
  </ng-template>
</mb-consent-overlay>
